<template>
  <LoadingBlock :loading="loading">
    <form @submit.prevent="submit">
      <p class="text-muted small mb-3">
        Файл ВИ (.xlsx) с колонками «Код товара на сайте», «Ссылка на РД», «Ссылка на файл сертификата».
        Код товара сопоставляется с кодом поставщика.
        Большой файл обрабатывается долго — прогресс видно в задаче.
      </p>

      <div
          class="dropzone mb-4"
          :class="{ 'dropzone-active': isDragging, 'dropzone-has-file': selectedFile }"
          @dragover.prevent="isDragging = true"
          @dragleave.prevent="isDragging = false"
          @drop.prevent="onDrop"
          @click="$refs.fileInput.click()"
      >
        <input ref="fileInput" type="file" class="d-none"
               accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
               @change="onFileChange">
        <div v-if="!selectedFile">
          <span class="ti ti-upload ti-lg d-block mb-2"></span>
          <p class="mb-1">Перетащите файл сюда или нажмите для выбора</p>
          <small class="text-muted">Только .xlsx</small>
        </div>
        <div v-else>
          <span class="ti ti-file-spreadsheet ti-lg d-block mb-2"></span>
          <p class="mb-0">{{ selectedFile.name }}</p>
        </div>
      </div>

      <p v-if="loading && waitingTask" class="text-center text-muted">Импорт запущен, открываем задачу…</p>

      <div class="text-center mt-4">
        <button type="submit" class="btn btn-primary" :disabled="!selectedFile || loading">
          Импортировать
        </button>
      </div>
    </form>
  </LoadingBlock>
</template>

<script>
import LoadingBlock from "@/components/page/LoadingBlock.vue";
import {Message, Messages} from "@/data/messages";
import {importLinks} from "@/api/certificate";
import {user} from "@/data/user";
import {CERTIFICATE_LINKS_IMPORT_TASK, parseRequestError} from "@/data/certificate";
import {getLatestTaskId, openStartedTask} from "@/helpers/task";

export default {
  name: "CertificateImportFileForm",
  components: {LoadingBlock},
  emits: ['started'],
  data() {
    return {
      loading: false,
      waitingTask: false,
      isDragging: false,
      selectedFile: null,
    }
  },
  methods: {
    reset() {
      this.selectedFile = null
      this.isDragging = false
      this.loading = false
      this.waitingTask = false
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = ''
      }
    },
    setFile(file) {
      if (!file.name.toLowerCase().endsWith('.xlsx')) {
        const message = new Message()
        message.type = 'failure'
        message.text = 'Нужен файл .xlsx'
        Messages.list.push(message)
        if (this.$refs.fileInput) {
          this.$refs.fileInput.value = ''
        }
        return
      }
      this.selectedFile = file
    },
    onFileChange(event) {
      const file = event.target.files?.[0]
      if (file) {
        this.setFile(file)
      }
    },
    onDrop(event) {
      this.isDragging = false
      const file = event.dataTransfer.files?.[0]
      if (file) {
        this.setFile(file)
      }
    },
    async submit() {
      if (!this.selectedFile || this.loading) {
        return
      }
      this.loading = true
      const message = new Message()
      try {
        const company_id = await user.getActiveCompany()
        const previousTaskId = await getLatestTaskId(company_id, CERTIFICATE_LINKS_IMPORT_TASK)
        const result = await importLinks(company_id, this.selectedFile)
        if (result.status === 202 || result.status === 200 || result.status === 201) {
          message.type = 'success'
          message.autoremove = 10
          message.text = 'Импорт запущен, результат — в задачах'
          Messages.list.push(message)
          this.$emit('started')
          this.waitingTask = true
          await openStartedTask(this.$router, company_id, CERTIFICATE_LINKS_IMPORT_TASK, previousTaskId)
          this.reset()
        } else {
          message.type = 'failure'
          message.text = 'Не удалось запустить импорт'
          Messages.list.push(message)
        }
      } catch (e) {
        message.type = 'failure'
        message.text = parseRequestError(e, 'Не удалось запустить импорт')
        Messages.list.push(message)
      }
      this.loading = false
      this.waitingTask = false
    },
  },
}
</script>

<style scoped>
.dropzone {
  border: 2px dashed #d9dee3;
  border-radius: 8px;
  padding: 2rem;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.2s, background-color 0.2s;
}

.dropzone:hover,
.dropzone-active {
  border-color: #696cff;
  background-color: #f8f8ff;
}

.dropzone-has-file {
  border-style: solid;
}
</style>
